/* Adaptado de revelatio-hero-clone/text-scramble.js: init manual (sin auto-run). */
(() => {
  if (window.__heroScrambleInit) return;
  window.__heroScrambleInit = true;

  const CHARS = '!<>-_\\/[]{}—=+*^?#0123456789';

  class TextScramble {
    constructor(el) {
      this.el = el;
      this.frame = 0;
      this.frameRequest = null;
      this.queue = [];
      this.resolve = null;
      this.update = this.update.bind(this);
    }
    setText(newText, speedMult) {
      const mult = speedMult || 1;
      const oldText = this.el.textContent;
      const length = Math.max(oldText.length, newText.length);
      const promise = new Promise((resolve) => { this.resolve = resolve; });
      this.queue = [];
      for (let i = 0; i < length; i += 1) {
        const from = oldText[i] || '';
        const to = newText[i] || '';
        const start = Math.floor(Math.random() * 28 * mult);
        const end = start + Math.floor(Math.random() * 28 * mult) + 8 * mult;
        this.queue.push({ from, to, start, end, char: '' });
      }
      if (this.frameRequest) cancelAnimationFrame(this.frameRequest);
      this.frame = 0;
      this.finalText = newText;
      this.update();
      return promise;
    }
    update() {
      let output = '';
      let complete = 0;
      for (let i = 0; i < this.queue.length; i += 1) {
        const item = this.queue[i];
        if (this.frame >= item.end) {
          complete += 1;
          output += item.to;
        } else if (this.frame >= item.start) {
          if (!item.char || Math.random() < 0.3) {
            item.char = CHARS[Math.floor(Math.random() * CHARS.length)];
          }
          output += `<span style="color:#8a8a8a">${item.char}</span>`;
        } else {
          output += item.from;
        }
      }
      this.el.innerHTML = output;
      if (complete === this.queue.length) {
        this.el.textContent = this.finalText;
        this.resolve();
      } else {
        this.frameRequest = requestAnimationFrame(this.update);
        this.frame += 1;
      }
    }
  }

  window.TextScrambleClass = TextScramble;
  window.initHeroScramble = function initHeroScramble(scope, speed) {
    const mult = speed || 1;
    const titles = (scope || document).querySelectorAll('[data-scramble]');
    titles.forEach((title) => {
      const lines = title.querySelectorAll('.line');
      lines.forEach((line, i) => {
        const finalText = line.getAttribute('data-text') || line.textContent;
        line.setAttribute('data-text', finalText);
        const fx = new TextScramble(line);
        setTimeout(() => fx.setText(finalText, mult), 300 + i * 220 * mult);
      });
    });
  };
})();
